export const resourceReservationsMainQueryKey = "resource-reservations";
